import { useDispatch } from "react-redux";
import { clearLocalOffers, useRemoveAllOffersComparisonMutation } from "@entities/compare";
import { DeleteIcon } from "@shared/ui/Icon/ui/Common/DeleteIcon";
import { CLEAR_COMPARE_TEXT } from "./constants";
import { ClearCompareProps } from "./types";
import classes from "./ClearCompare.module.scss";

export const ClearCompare = ({ isLocalOnly }: ClearCompareProps) => {
    const dispatch = useDispatch();
    const [removeAllOffersComparison, { isLoading }] = useRemoveAllOffersComparisonMutation();

    const handleClear = async () => {
        if (isLocalOnly) {
            dispatch(clearLocalOffers());
            return;
        }

        await removeAllOffersComparison().unwrap();
    };

    return (
        <button className={classes["clear-compare"]} onClick={handleClear} disabled={isLoading}>
            <DeleteIcon className={classes["clear-compare__icon"]} />
            {CLEAR_COMPARE_TEXT}
        </button>
    );
};